import { useFlags } from "launchdarkly-react-client-sdk";

import { usePersonalization } from "src/hooks/use-personalization";
import { useShouldShowAiFeaturesAnnouncement } from "src/hooks/use-should-show-ai-features-announcement";
import { useShouldSuppressFeatureAnnouncements } from "src/hooks/use-should-suppress-feature-announcements";

export const useShouldShowLcmIntroDialog = () => {
  // Kill switch — same pattern as `appHideAudiencesAgentAnnouncement`, so the
  // modal can be turned off for internal users (or everyone) from LaunchDarkly.
  const { appHideLcmIntroModal } = useFlags();
  const shouldSuppressAnnouncements = useShouldSuppressFeatureAnnouncements();
  // Defer to the globally-mounted AI-features announcement so the two dialogs
  // never stack on a Lifecycle Studio page.
  const { shouldShow: shouldShowAiFeaturesAnnouncement } =
    useShouldShowAiFeaturesAnnouncement();
  const { value: isDismissed, setLocal: setIsDismissed } =
    usePersonalization<boolean>({
      key: "lcm.intro-modal-dismissed",
      initialValue: false,
      useWorkspace: false,
    });

  return {
    setIsDismissed,
    shouldShow:
      !isDismissed &&
      !appHideLcmIntroModal &&
      !shouldShowAiFeaturesAnnouncement &&
      !shouldSuppressAnnouncements,
  };
};
